import { render, staticRenderFns } from "./AddPersonDialog.vue?vue&type=template&id=567c5abe"
import script from "./AddPersonDialog.vue?vue&type=script&lang=js"
export * from "./AddPersonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports